import { render, staticRenderFns } from "./port.vue?vue&type=template&id=360147e2&scoped=true&"
import script from "./port.vue?vue&type=script&lang=js&"
export * from "./port.vue?vue&type=script&lang=js&"
import style0 from "./port.vue?vue&type=style&index=0&id=360147e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360147e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360147e2')) {
      api.createRecord('360147e2', component.options)
    } else {
      api.reload('360147e2', component.options)
    }
    module.hot.accept("./port.vue?vue&type=template&id=360147e2&scoped=true&", function () {
      api.rerender('360147e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/port.vue"
export default component.exports